import { Button as ButtonHulu } from '@hulu/react-style-components';
import CommunityLoader from '@hulu-react-style-components/community-loader';
import styled from 'styled-components';

export const StyledButton = styled(ButtonHulu)`
  margin: 0;
  padding: ${({ theme: { spacers } }): string => `${spacers!.spacer04} ${spacers!.spacer05}`};

  span {
    letter-spacing: 0;
    font-family: Graphik;
    font-weight: 500;
  }

  &.primary {
    background: ${({ disabled, theme }): string =>
      !disabled ? theme.admanColors!.gray.light.fg[0] : theme.admanColors!.gray.light.bg0[6]};
    color: ${({ disabled, theme }): string =>
      !disabled ? theme.admanColors!.gray.light.bg1[0] : theme.admanColors!.gray.dark.fg[1]};

    &:hover {
      background: ${({ disabled, theme }): string => (!disabled ? theme.admanColors!.gray.light.fg[1] : 'inherit')};
    }

    &:active {
      background: ${({ disabled, theme }): string => (!disabled ? theme.admanColors!.gray.dark.fg[4] : 'inherit')};
    }
  }

  &.TrekButton-outlined {
    border: ${({ disabled, theme }): string =>
      `2px solid ${!disabled ? theme.admanColors!.gray.light.fg[0] : theme.admanColors!.gray.dark.fg[1]}`};
    color: ${({ disabled, theme }): string =>
      !disabled ? theme.admanColors!.gray.light.fg[0] : theme.admanColors!.gray.dark.fg[1]};

    &:hover {
      background: ${({ disabled, theme }): string => (!disabled ? theme.admanColors!.gray.dark.fg[0] : 'inherit')};
      border: 2px solid
        ${({ disabled, theme }): string => (!disabled ? theme.admanColors!.gray.light.fg[0] : 'inherit')};
    }

    &:active {
      background: ${({ disabled, theme }): string => (!disabled ? theme.admanColors!.gray.light.bg0[3] : 'inherit')};
    }
  }

  &.tertiaryButton {
    border-width: 0;
    color: ${({ disabled, theme }): string => (disabled ? theme.admanColors!.gray.light.fg[5] : 'inherit')};

    &:hover {
      background: ${({ disabled, theme }): string => (!disabled ? theme.admanColors!.gray.light.bg0[2] : 'inherit')};
      border: none;
    }

    &:active {
      background: ${({ disabled, theme }): string => (!disabled ? theme.admanColors!.gray.light.bg0[3] : 'inherit')};
    }
  }
`;

export const ButtonName = styled.span<{ isLoading?: boolean }>`
  position: relative;
  font-weight: 500;
  font-size: 14px;
  text-transform: none;
  color: ${({ isLoading }): string => (isLoading ? 'transparent' : 'inherit')};
  user-select: none;
`;

export const StyledLoader = styled(CommunityLoader)`
  width: ${({ theme: { spacers } }): string => spacers!.spacer04};
  height: ${({ theme: { spacers } }): string => spacers!.spacer04};
  position: absolute;
  border-width: 3px;
  left: calc(50% - 8px);
  top: calc(50% - 8px);
`;
